import { render, staticRenderFns } from "./partinformation.vue?vue&type=template&id=67ebf86c&"
import script from "./../../ts/projecttablerows/partinformation.ts?vue&type=script&lang=js&"
export * from "./../../ts/projecttablerows/partinformation.ts?vue&type=script&lang=js&"
import style0 from "./../../assets/css/projecttablerows/partinformation.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports